import { Sex } from "../types";

const log10 = Math.log10;

type FatFractionParams = {
  sex: Sex;
  neck: {
    centimeters: number;
  };
  waist: {
    centimeters: number;
  };
  height: {
    centimeters: number;
  };
  hip?: {
    centimeters: number;
  };
};

interface FatFractionResult {
  fatFraction: number;
}

function calcFatFraction({
  waist,
  neck,
  height,
  hip,
  sex,
}: FatFractionParams): FatFractionResult {
  if (sex === "male") {
    return {
      fatFraction: fatFractionMale({ waist, neck, height }),
    };
  }

  if (sex === "female" && hip !== undefined) {
    return {
      fatFraction: fatFractionFemale({ waist, neck, hip, height }),
    };
  }

  return {
    fatFraction: NaN,
  };
}

interface FatFractionMaleParams {
  waist: {
    centimeters: number;
  };
  neck: {
    centimeters: number;
  };
  height: {
    centimeters: number;
  };
}

function fatFractionMale({ waist, neck, height }: FatFractionMaleParams) {
  return (
    495 /
      (1.0324 -
        0.19077 * log10(waist.centimeters - neck.centimeters) +
        0.15456 * log10(height.centimeters)) -
    450
  );
}

interface FatFractionFemaleParams {
  waist: {
    centimeters: number;
  };
  neck: {
    centimeters: number;
  };
  height: {
    centimeters: number;
  };
  hip: {
    centimeters: number;
  };
}

function fatFractionFemale({
  waist,
  neck,
  height,
  hip,
}: FatFractionFemaleParams) {
  return (
    495 /
      (1.29579 -
        0.35004 *
          log10(waist.centimeters + hip.centimeters - neck.centimeters) +
        0.221 * log10(height.centimeters)) -
    450
  );
}

export const FatFraction = {
  calculate: calcFatFraction,
};
